import { useEffect } from "react";
import { Navigate, useParams } from "react-router";
import { toast } from "sonner";
import { useCustomerChat } from "@/components/journey/CustomerChatProvider";
import { useAccountWorkspace } from "@/lib/account-workspace";
import { ApiError, getWecomExternalContact } from "@/lib/wecom-external-contacts";

/** 深链：拉取联系人 → 打开全屏聊天窗 → 回到父列表 */
export default function JourneyCustomerChatDeepLink() {
  const { contactId } = useParams();
  const { accountId } = useAccountWorkspace();
  const { openCustomerChat } = useCustomerChat();

  useEffect(() => {
    if (!contactId) return;

    let cancelled = false;

    void getWecomExternalContact(accountId, contactId)
      .then((c) => {
        if (cancelled) return;
        openCustomerChat(c);
      })
      .catch((caught) => {
        if (cancelled) return;
        const message =
          caught instanceof ApiError && caught.status === 404
            ? "找不到该客户"
            : caught instanceof ApiError
              ? caught.message
              : "无法打开客户聊天";
        toast.error(message);
      });

    return () => {
      cancelled = true;
    };
  }, [accountId, contactId, openCustomerChat]);

  return <Navigate to=".." relative="path" replace />;
}
